<template>
  <div class="import-file-popup">
    <!-- <el-dropdown @command="upLoadFile"> -->
      <!-- <el-button type="primary" @click="dialogVisible=true">
        批量上传
        <i class="el-icon-upload2" />
      </el-button> -->
      <!-- <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="1">天眼查导入</el-dropdown-item>
        <el-dropdown-item command="2">本地导入</el-dropdown-item>
      </el-dropdown-menu> -->
    <!-- </el-dropdown> -->

    <el-dialog
      :visible.sync="dialogVisible"
      width="524px"
      :before-close="handleClose"
    >
      <template v-slot:title>
        <p class="add-title">{{ popupTitle }}</p>
      </template>

      <div class="upload-box">
        <div class="upload-btn">
          <ImportData
            :moduleName="moduleName"
            buttonType="primary"
            :buttonText="buttonText"
            @uploadSuccess="(e) => $emit('uploadSuccess', e)"
          />
        </div>

        <p class="download-link">
          <span>请按指定模板上传，</span>
          <a class="download-btn" :href="templateUrl">下载模板</a>
        </p>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
// components
import ImportData from "@/components/ImportData.vue";

// api
import { downloadTemplate,clientEnterprise } from "@/api/common.js";

// utils
import { downFile } from "@/utils/tool";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    ImportData,
  },
  props: {
    buttonText: {
      type: String,
      default: "上传文件",
    },
    popupTitle: {
      type: String,
      default: "",
    },
    moduleName: {
      type: String,
      default: "",
    },
    templateName: {
      type: String,
      default: "",
    },
    templateUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    //这里存放数据
    return {
      dialogVisible: false,
    };
  },
  methods: {
    show() {
      this.dialogVisible = true;
    },
    handleClose(done) {
      done();
    },
    upLoadFile(flag) {
      if (flag == 1) {
        this.dialogVisible = true;
      } else {
        console.log('qqqqqqqqqqqqq')
        clientEnterprise().then(res=>{
          console.log(res)
        })
      }
    },
    downloadTemplate() {
      this.$modal.loading("正在获取模版，请稍候...");
      downloadTemplate({ name: this.templateName })
        .then((res) => {
          downFile(
            { urlStr: this.getSeverFileUrl(res.data.importTemplateUrl) }, // 后台需要的参数
            "/public/downloadUrlFile", // 路径
            res.data.importTemplatetype,
            res.data.importTemplateName
          );
        })
        .finally(() => {
          this.$modal.closeLoading();
        });
    },
  },
};
</script>

<style scoped lang="less">
.import-file-popup {
  .add-title {
    text-align: left;
    color: #333333;
  }
  .upload-btn {
    margin-left: 182px;
  }

  .download-link {
    display: flex;
    justify-content: center;
    margin-top: 19px;
  }

  .download-btn {
    color: #1e9fff;
    cursor: pointer;
  }

  a {
    color: #1e9fff;
  }
}
</style>
